/**
 * The question the context header pins above the thread: the latest one the user asked, so a
 * follow-up replaces the first (Pegah, 2026-11-01: "each question on the thread"); before any
 * message of the thread is loaded, the conversation's title or first message, as before. Pure,
 * so the choice is tested apart from the chat.
 */
export function pinnedQuestion(
  messages: ReadonlyArray<{ role: string; content?: string | null }>,
  conversation: { title?: string | null; first_message?: string | null } | null | undefined
): string {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const m = messages[i]
    if (m.role === 'user' && m.content?.trim()) return m.content
  }
  return conversation?.title?.trim() || conversation?.first_message?.trim() || ''
}
